import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
    X,
    Mail,
    Trophy,
    Calendar,
    Flame,
    Target,
    Award,
    BarChart3,
    Loader2,
    CheckCircle2
} from "lucide-react";

import "./CustomerDrawer.css";

const CustomerDrawer = ({

  open,

  email,

  onClose

}) => {

  const [loading, setLoading] = useState(false);

  const [customer, setCustomer] = useState(null);

  const [journey, setJourney] = useState(null);

  const [stats, setStats] = useState(null);

  const [uploads, setUploads] = useState([]);

  const [achievements, setAchievements] = useState([]);

  const [recentActivity, setRecentActivity] = useState([]);
  const [courseStatus, setCourseStatus] = useState({

    neuroPerformanceFoundational: false,

    eyeHealthAthleticEdition: false,

    eyeHealthDetailed: false,

    allCoursesCompleted: false

});

const [courseLoading, setCourseLoading] = useState(false);

useEffect(() => {

    if (
        open &&
        email
    ) {

        fetchCustomer();

        fetchCourseStatus();

    }

}, [
    open,
    email
]);
 

  const fetchCustomer = async () => {

    try {

      setLoading(true);

      const res = await axios.get(

        `/api/admin/customer/${email}`

      );

      if (

        res.data.success

      ) {

        setCustomer(

          res.data.user

        );

        setJourney(

          res.data.journey

        );

        setStats(

          res.data.stats

        );

        setUploads(

          res.data.uploads || []

        );

        setAchievements(

          res.data.achievements || []

        );

        setRecentActivity(

          res.data.recentActivity || []

        );
        fetchCourseStatus();

      }

    }

    catch (err) {

      console.log(err);

      alert(

        err.response?.data?.message ||

        "Unable to load customer."

      );

    }

    finally {

      setLoading(false);

    }

  };

  const fetchCourseStatus = async () => {

    if (!email) return;

    try {

        const res = await axios.get(

            `/api/ignite/course/status/${email}`

        );

        if (res.data.success) {

            setCourseStatus({

                neuroPerformanceFoundational:
                    res.data.courses
                        ?.neuroPerformanceFoundational || false,

                eyeHealthAthleticEdition:
                    res.data.courses
                        ?.eyeHealthAthleticEdition || false,

                eyeHealthDetailed:
                    res.data.courses
                        ?.eyeHealthDetailed || false,

                allCoursesCompleted:
                    res.data.allCoursesCompleted || false

            });

        }

    }

    catch (err) {

        console.error(
            "Course Status Error:",
            err
        );

    }

};
const updateCourse = async (
    course,
    completed
) => {

    try {

        setCourseLoading(true);

        const res = await axios.patch(

            "/api/ignite/course/status",

            {

                email,

                course,

                completed

            }

        );

        if (res.data.success) {

            setCourseStatus({

                neuroPerformanceFoundational:
                    res.data.courses
                        ?.neuroPerformanceFoundational || false,

                eyeHealthAthleticEdition:
                    res.data.courses
                        ?.eyeHealthAthleticEdition || false,

                eyeHealthDetailed:
                    res.data.courses
                        ?.eyeHealthDetailed || false,

                allCoursesCompleted:
                    res.data.allCoursesCompleted || false

            });

            setJourney(
                res.data.journey
            );

        }

    }

    catch (err) {

        console.error(
            "Course Update Error:",
            err
        );

        alert(

            err.response?.data?.message ||

            "Unable to update course status."

        );

    }

    finally {

        setCourseLoading(false);

    }

};
  useEffect(() => {

    const close = (e) => {

      if (

        e.key === "Escape"

      ) {

        onClose();

      }

    };

    window.addEventListener(

      "keydown",

      close

    );

    return () =>

      window.removeEventListener(

        "keydown",

        close

      );

  }, [onClose]);

  if (!open) return null;

  return (

    <>

      <div

        className="drawer-overlay"

        onClick={onClose}

      />

      <div className="customer-drawer">

        <div className="drawer-header">

          <div>

            <h2>

              Customer Details

            </h2>

            <p>

              Vision Ignite Progress

            </p>

          </div>

          <button

            className="close-btn"

            onClick={onClose}

          >

            <X size={22} />

          </button>

        </div>

        {

          loading ?

          (

            <div className="drawer-loading">

              <Loader2

                size={40}

                className="spin"

              />

              <p>

                Loading Customer...

              </p>

            </div>

          )

          :

          customer && (

            <>
            <div className="drawer-body">

  <div className="profile-card">

    <div className="profile-avatar">

      {

        customer.profilePhoto ?

        (

          <img

            src={customer.profilePhoto}

            alt="Profile"

          />

        )

        :

        (

          <div className="avatar-placeholder">

            {

              customer.name

              ?.charAt(0)

              ?.toUpperCase()

            }

          </div>

        )

      }

    </div>

    <div className="profile-info">

      <h3>

        {

          customer.name ||

          "Customer"

        }

      </h3>

      <p>

        <Mail size={15}/>

        {customer.email}

      </p>

      <div className="level-badge">

        Level

        {

          journey?.currentLevel || 1

        }

      </div>

    </div>

  </div>

  <div className="drawer-section">

    <h3>

      <Target size={18}/>

      Journey Progress

    </h3>

    <div className="journey-list">

      <div className={

        journey?.currentLevel >=1 ?

        "journey-item completed"

        :

        "journey-item"

      }>

        Rookie

      </div>

      <div className={

        journey?.currentLevel >=2 ?

        "journey-item completed"

        :

        "journey-item"

      }>

        Contender

      </div>

      <div className={

        journey?.currentLevel >=3 ?

        "journey-item completed"

        :

        "journey-item"

      }>

        Performer

      </div>

      <div className={

        journey?.currentLevel >=4 ?

        "journey-item completed"

        :

        "journey-item"

      }>

        Elite

      </div>

    </div>

  </div>
 <div className="drawer-section">

    <h3>

        <CheckCircle2 size={18} />

        Course Completion

    </h3>


    <div className="course-list">


        {/* COURSE 1 */}

        <div className="course-item">

            <div>

                <strong>

                    Neuro Performance Foundational Program

                </strong>

                <small>

                    Foundational performance training

                </small>

            </div>


            <button

                className={

                    courseStatus
                        .neuroPerformanceFoundational

                        ? "course-toggle completed"

                        : "course-toggle"

                }

                disabled={courseLoading}

                onClick={() =>

                    updateCourse(

                        "neuroPerformanceFoundational",

                        !courseStatus
                            .neuroPerformanceFoundational

                    )

                }

            >

                {

                    courseStatus
                        .neuroPerformanceFoundational

                        ? "✓ Completed"

                        : "Mark Completed"

                }

            </button>

        </div>


        {/* COURSE 2 */}

        <div className="course-item">

            <div>

                <strong>

                    Eye Health Reset – Athletic Edition

                </strong>

                <small>

                    Athletic eye health program

                </small>

            </div>


            <button

                className={

                    courseStatus
                        .eyeHealthAthleticEdition

                        ? "course-toggle completed"

                        : "course-toggle"

                }

                disabled={courseLoading}

                onClick={() =>

                    updateCourse(

                        "eyeHealthAthleticEdition",

                        !courseStatus
                            .eyeHealthAthleticEdition

                    )

                }

            >

                {

                    courseStatus
                        .eyeHealthAthleticEdition

                        ? "✓ Completed"

                        : "Mark Completed"

                }

            </button>

        </div>


        {/* COURSE 3 */}

        <div className="course-item">

            <div>

                <strong>

                    Eye Health Reset – Detailed

                </strong>

                <small>

                    Detailed eye health program

                </small>

            </div>


            <button

                className={

                    courseStatus
                        .eyeHealthDetailed

                        ? "course-toggle completed"

                        : "course-toggle"

                }

                disabled={courseLoading}

                onClick={() =>

                    updateCourse(

                        "eyeHealthDetailed",

                        !courseStatus
                            .eyeHealthDetailed

                    )

                }

            >

                {

                    courseStatus
                        .eyeHealthDetailed

                        ? "✓ Completed"

                        : "Mark Completed"

                }

            </button>

        </div>


        {/* SUMMARY */}

        <div className="course-summary">

            <strong>

                {

                    [

                        courseStatus
                            .neuroPerformanceFoundational,

                        courseStatus
                            .eyeHealthAthleticEdition,

                        courseStatus
                            .eyeHealthDetailed

                    ].filter(Boolean).length

                }

                /3 Courses Completed

            </strong>


            {

                courseStatus.allCoursesCompleted

                    ?

                    <span className="all-courses-complete">

                        ✓ All courses completed

                    </span>

                    :

                    <span>

                        Complete all 3 courses to unlock
                        the course objective.

                    </span>

            }

        </div>

    </div>

</div>
  <div className="drawer-section">

    <h3>

      <BarChart3 size={18}/>

      Statistics

    </h3>

    <div className="stats-grid">

      <div className="stat-box">

        <h4>

          Assessments

        </h4>

        <span>

          {

            stats?.totalAssessments ||

            0

          }

        </span>

      </div>

      <div className="stat-box">

        <h4>

          Current Streak

        </h4>

        <span>

          {

            stats?.currentStreak ||

            0

          }

        </span>

      </div>

      <div className="stat-box">

        <h4>

          Longest Streak

        </h4>

        <span>

          {

            stats?.longestStreak ||

            0

          }

        </span>

      </div>

      <div className="stat-box">

        <h4>

          Rank

        </h4>

        <span>

          {

            journey?.leaderboardRank ??

            "-"

          }

        </span>

      </div>

    </div>

  </div>

  <div className="drawer-section">

    <h3>

      Uploaded Videos

    </h3>

    <div className="uploads-grid">

      {

        uploads.length ?

        uploads.map(upload=>(

          <div

            key={upload._id}

            className="upload-item"

          >

            <p>

              {upload.type}

            </p>

            <video

              controls

              preload="metadata"

            >

              <source

                src={upload.fileUrl}

                type="video/mp4"

              />

            </video>

          </div>

        ))

        :

        <p>

          No Uploads

        </p>

      }

    </div>

  </div>

  <div className="drawer-section">

    <h3>

      <Award size={18}/>

      Achievements

    </h3>

    <div className="achievement-grid">

      {

        achievements.length ?

        achievements.map(item=>(

          <div

            key={item._id}

            className="achievement-card"

          >

            🏆

            <span>

              {

                item.title ||

                item.name

              }

            </span>

          </div>

        ))

        :

        <p>

          No Achievements

        </p>

      }

    </div>

  </div>

  <div className="drawer-section">

    <h3>

      <Calendar size={18}/>

      Recent Activity

    </h3>

    <div className="activity-list">

      {

        recentActivity.length ?

        recentActivity.map(activity=>(

          <div

            key={activity._id}

            className="activity-item"

          >

            <strong>

              {

                activity.title

              }

            </strong>

            <small>

              {

                new Date(

                  activity.createdAt

                ).toLocaleString()

              }

            </small>

          </div>

        ))

        :

        <p>

          No Recent Activity

        </p>

      }

    </div>

  </div>

  </div>

            </>

          )

        }

      </div>

    </>

  );

};

export default CustomerDrawer;